import React from "react";
import { Card, Col, Icon } from "antd";
import UserContext from "../Contexts/UserContext";
import CollapseMenu from "../Components/Profile/CollapseMenu";

const Profile = () => {
  return (
    <UserContext.Consumer>
      {({ profile }) => {
        const { email, name, phone_number } = profile.attributes;
        return (
          <div
            style={{
              minHeight: "100vh",
              position: "relative",
              overflow: "hidden"
            }}
          >
            <div className="profile-background" />
            <div style={{ position: "relative", zIndex: 2 }}>
              <Col
                style={{ marginTop: "10rem" }}
                xs={{ span: 22, offset: 1 }}
                sm={{ span: 22, offset: 1 }}
                md={{ span: 18, offset: 3 }}
                lg={{ span: 18, offset: 3 }}
                xl={{ span: 18, offset: 3 }}
              >
                <Card
                  style={{
                    boxShadow: "var(--shadow-super-light)",
                    borderRadius: 20,
                    backgroundColor: "transparent"
                  }}
                >
                  <Col
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center"
                    }}
                    xs={{ span: 22 }}
                    sm={{ span: 22 }}
                    md={{ span: 4 }}
                    lg={{ span: 4 }}
                    xl={{ span: 4 }}
                  >
                    <Icon type="user" style={{ fontSize: 100 }} />
                  </Col>
                  <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 20 }}
                    lg={{ span: 20 }}
                    xl={{ span: 20 }}
                    style={{ fontSize: "1.6rem" }}
                  >
                    <div className="content__text-detail">
                      <span style={{ fontWeight: "bold" }}>Nombre:</span>
                      <span style={{ color: "white" }}>{name}</span>
                    </div>
                    <div className="content__text-detail">
                      <span style={{ fontWeight: "bold" }}>Correo:</span>
                      <span style={{ color: "white" }}>{email}</span>
                    </div>
                    <div className="content__text-detail">
                      <span style={{ fontWeight: "bold" }}>Teléfono:</span>
                      <span style={{ color: "white" }}>{phone_number}</span>
                    </div>
                  </Col>
                </Card>
              </Col>
              <Col
                xs={{ span: 22, offset: 1 }}
                sm={{ span: 22, offset: 1 }}
                md={{ span: 12, offset: 5 }}
                lg={{ span: 12, offset: 5 }}
                xl={{ span: 8, offset: 5 }}
                style={{ marginTop: "3.5rem" }}
              >
                <CollapseMenu user={profile} />
              </Col>
            </div>
          </div>
        );
      }}
    </UserContext.Consumer>
  );
};

export default Profile;



// WEBPACK FOOTER //
// ./src/Pages/Profile.js